import axios from "axios";

// const apiUrl = process.env.API_BASE_URL
const API_URL = process.env.REACT_APP_API_BASE_URL;


const $api = axios.create({
    // withCredentials: true,
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    }
});

$api.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('authToken')}`
    return config;
});

$api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const status = error.response.status;

            if (status === 401) {
                console.log('Error 401: Unauthorized');
                localStorage.clear();
                window.location.href = '/login';
            }
        } 
    }
)

export default $api;